/**
 * Функция для работы с запросами.
 * @param {Object} settings
 * @param {String} settings.url
 * @param {Function} settings.onSuccess - Функция обработки успеха запроса.
 * @param {Function} settings.onFail - Функция обработки ошибки запроса.
 * @param {Object} settings.options - Объект опций, принимаемых fetch. Например, method, headers, body...
 * @param {Boolean} settings.isXMLHttp - Флаг добавления заголовка 'x-requested-with': 'XMLHttpRequest' для ajax.
 * @param {String} settings.responseType - Тип ожидаемого ответа от сервера.
 * @return {Promise<any>}
 */
export var fetchData = function fetchData(_ref) {
  var url = _ref.url,
      onSuccess = _ref.onSuccess,
      onFail = _ref.onFail,
      options = _ref.options,
      isXMLHttp = _ref.isXMLHttp,
      responseType = _ref.responseType;
  var headers = new Headers(isXMLHttp ? {
    'x-requested-with': 'XMLHttpRequest'
  } : {});
  return fetch(url, Object.assign({}, {
    credentials: isXMLHttp ? 'include' : 'same-origin',
    headers: headers
  }, options)).then(function (response) {
    return response.ok ? response[responseType || 'json']() : Promise.reject(response);
  }).then(function (data) {
    return onSuccess ? onSuccess(data) : data;
  })["catch"](function (response) {
    if (onFail) {
      return onFail(response);
    } else {
      throw new Error("failed to load data from: ".concat(url, " \n status: ").concat(response.status));
    }
  });
};